import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { INMTestigosService } from '../../services/inmtestigos.service';
import { ApiResult } from './../../models/ApiResult';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component'
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CurrencyFormatPipe } from '../../pipes/currency-format.pipe';

@Component({
  selector: 'app-inmtestigos',
  templateUrl: './inmtestigos.component.html',
  styleUrls: ['./inmtestigos.component.scss']
})
export class INMTestigosComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  public rowData: any;
  searchTerm: FormControl = new FormControl();
  public gridApi;

  private _rowsIdSelectedList: number[] = [];
  public mostarBoton:boolean = false;
  public rowsDelete:string;
  private _maxMostrar:number = 5;

  //mensajes
  public mensajeError:string = null;
  public mensajeCorrecto:string = null;



  createColumnDef() {
    const columnDefs = [
      { headerName: this.translate.instant('tasaciones.header_archivo'), field: 'nombreFicheroExcel', width: 230 },
      { headerName: this.translate.instant('tasaciones.header_codtasacion'), field: 'codTasacionOrigen', width: 150 },
      { headerName: this.translate.instant('tasaciones.header_numtestigo'), field: 'numLineaTestigo', width: 120 },
      { headerName: this.translate.instant('tasaciones.header_tipoinmueble'), field: 'tipoTestigoNombre', minWidth: 350 },
      { headerName: this.translate.instant('tasaciones.header_vglobal'), field: 'valorGlobal', minWidth: 120, valueFormatter: (data) => this._currencyFormatPipe.transform(data.value)},
      { headerName: this.translate.instant('tasaciones.header_vunitario'), field: 'valorUnitario', minWidth: 90, valueFormatter: (data) => this._currencyFormatPipe.transform(data.value,'')},
      { headerName: this.translate.instant('tasaciones.header_anioConstrcion'), field: 'anioConstr', minWidth: 120 },
      { headerName: this.translate.instant('tasaciones.header_direccion'), field: 'direccion', minWidth: 350 },
      { headerName: this.translate.instant('tasaciones.header_localidad'), field: 'localidad', minWidth: 150 },
      
      {headerName: this.translate.instant('tasaciones.header_fechaaAnalisis'), field: 'fechaAnalisis', minWidth: 90,cellRendererFramework: CellDateFormatterComponent },
      {headerName: this.translate.instant('tasaciones.header_fechaAlta'), field: 'createdDate', minWidth: 90,cellRendererFramework: CellDateFormatterComponent }
      
    ];


    return columnDefs;
  }

  constructor(private _INMTestigosService: INMTestigosService, private _router: Router, private _route: ActivatedRoute,
    public _authService: AuthService, _translateService: TranslateService,private _currencyFormatPipe: CurrencyFormatPipe) {

    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();

  }

  ngOnInit() {
    this.translate.use(this.translate.currentLang);
    this.getTasaciones();

    this.searchTerm.valueChanges.pipe(debounceTime(400)).subscribe(data => {
      this.getTasaciones();
    });    

  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  public getTasaciones() {
    let svc: Observable<any>;

    if (this.searchTerm.value != null) {
      svc = this._INMTestigosService.getINMTestigosFiltered(this.searchTerm.value);
    } else {
      svc = this._INMTestigosService.getINMTestigos();
    }

    svc.subscribe(data => {
      this.rowData = data; 
      //console.log(data);     
    }, (err) => {
      console.error('Error al recuperar datos de clientes');
    });

    
  }

  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      const data = e.data;
      const actionType = e.event.target.getAttribute('data-action-type');    
      
      //switch (actionType) {
      //  case 'remove':
      //    return this.onActionRemoveClick(data);

      //}
    }
  }

  closeAlertCorrecto() {
    
    this.mensajeCorrecto = null;    
  }

  closeAlertIncorrecto() {
    
    this.mensajeError = null;
  }

  cerrarBoton()
{
   this.closeAlertCorrecto();
   this.closeAlertIncorrecto();
   this._rowsIdSelectedList = null;   
   this.gridApi.deselectAll();
   this.mostarBoton = false;
}

  public borrarTestigos()
  {
    if(this._rowsIdSelectedList.length)
    {
      this.mostarBoton = false;
      var ans = confirm("Quieres eliminar " + this.rowsDelete + " seleccionados" );
      if (ans) {        
        this._INMTestigosService.deleteTestigos(this._rowsIdSelectedList)
        .subscribe({
          next: (apiResult: ApiResult) => {
            if (apiResult.correct) {                       
              this.mensajeCorrecto = apiResult.mensaje;              
              this.ngOnInit();
            }
            else {
              this.mensajeError = apiResult.mensaje;
            }
          },
          error: (error) => {

          }
        });
      }
    }

  }

  getSelectedItem() {

    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      const rowid = selectedRow.data.id;
      console.log(rowid);
      return rowid;

    } else {
      return null;
    }
  }

  //Recibe los elementos seleccionados del ag-grid-angular
  getSelectedItems(e) {

      var selected = this.gridApi.getSelectedNodes();    

      if(selected.length >= 0)
      {
        this.mostarBoton = true;
      }
      
      let valrows:any[]=[];   
      var selectedString = '';   
      var max = this._maxMostrar;

      selected.forEach(function(selectedRow, index)
      {        
        valrows.push(selectedRow.data.id);              
      });

      selectedString = ' + ' + valrows.length.toString();
      
      this._rowsIdSelectedList = valrows;
      this.rowsDelete = selectedString;

  }

  onActionRemoveClick(rows:any[])
  {
 

  }


}